import {ssg, sss} from "./common-utils.ts";

const STORAGE_KEY = "shows-view";

/**
 * Shows page grid/list view is a pure-CSS radio toggle.  The only thing
 * JS does is persist the user's choice across navigations: on load, restore the remembered
 * radio; on change, remember the new one. With JS disabled the server default (grid, checked in the
 * template) renders and the toggle still works — this just adds memory of the last choice.
 */
export const renderShowsPageView = () => {
    const holder = document.getElementById("shows-page-holder");
    if (!holder) return;

    const gridRadio = document.getElementById("view-grid") as HTMLInputElement | null;
    const listRadio = document.getElementById("view-list") as HTMLInputElement | null;
    if (!gridRadio || !listRadio) return;

    // Restore the remembered view (server default is grid via the template's `checked`).
    const stored = ssg(STORAGE_KEY);
    if (stored === "list") {
        listRadio.checked = true;
    } else if (stored === "grid") {
        gridRadio.checked = true;
    }

    // Persist on change; CSS handles the actual show/hide.
    holder.querySelectorAll<HTMLInputElement>("input[name='shows-view']").forEach(radio => {
        radio.addEventListener("change", () => {
            if (radio.checked) sss(STORAGE_KEY, radio.value);
        });
    });
};
